import "./App.scss";
import HomePage from "./components/HomePage/HomePage";

function App() {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <HomePage />
    </div>
  );
}

export default App;
